// import {
//   CompanyTypeSelectionWidget,
//   CompanyBranchSelectionWidget,
//   CompanyActivitySelectionWidget,
// } from "components/FormWidget";

const uiSchema = () => ({
  national_identifier: {
    "ui:options": {
      inputMode: "numeric", // کیبورد عددی باز می‌شود
      pattern: "[0-9]*", // برای دستگاه‌های iOS
    },
  },
  registered_number: {
    "ui:options": {
      inputMode: "numeric", // کیبورد عددی باز می‌شود
      pattern: "[0-9]*", // برای دستگاه‌های iOS
    },
  },
  postal_code: {
    "ui:options": {
      inputMode: "numeric", // کیبورد عددی باز می‌شود
      pattern: "[0-9]*", // برای دستگاه‌های iOS
    },
  },
  tellphone: {
    "ui:options": {
      inputMode: "tel",
      autoComplete: "tel",
    },
    "ui:placeholder": "09123456789",
  },
  // type_id: {
  //   "ui:widget": CompanyTypeSelectionWidget,
  // },
  // activity_id: {
  //   "ui:widget": CompanyActivitySelectionWidget,
  // },
  // branch_type_id: {
  //   "ui:widget": CompanyBranchSelectionWidget,
  // },
  register_date: {
    "ui:field": "date",
  },
  location: {
    "ui:field": "location",
  },
  address: {
    "ui:widget": "textarea",
  },
});

export default uiSchema;
